document.querySelector('.menu-btn').addEventListener('click', event => {
	event.preventDefault();
	const nav = document.querySelector('.drawer-nav');
	nav.classList.toggle('active');
	document.body.style.overflow = 'hidden';
	document.body.classList.toggle('menu-open');
});

document.querySelector('.close-menu-btn').addEventListener('click', event => {
	event.preventDefault();
	const nav = document.querySelector('.drawer-nav');
	nav.classList.remove('active');
	document.body.style.overflow = '';
	document.body.classList.remove('menu-open');
});